/* Willow behavior for the Judge.me product review widget.
   Configuration is read from the script tag rendered by sections/apps.liquid. */
(function willowReviewEnhancer(){
    var configScript=document.currentScript;
    var serverRating=Number(configScript&&configScript.dataset.rating)||0;
    var serverCount=Number(configScript&&configScript.dataset.count)||0;
    var modernRootSelector='[data-widget-container="review-widget"],.jm-review-widget,[data-judgeme-review-widget]';
    var scopedModernRootSelector=[
      '#judgeme_product_reviews[data-widget-container="review-widget"]',
      '#judgeme_product_reviews [data-widget-container="review-widget"]',
      '#judgeme_product_reviews.jm-review-widget',
      '#judgeme_product_reviews .jm-review-widget',
      '#judgeme_product_reviews[data-judgeme-review-widget]',
      '#judgeme_product_reviews [data-judgeme-review-widget]'
    ].join(',');

    function averageFrom(widget){
      if(serverRating>0){return serverRating;}
      var holder=widget.querySelector('[data-average-rating]')||widget.closest('[data-average-rating]');
      var raw=holder&&holder.getAttribute('data-average-rating');
      if(raw&&Number(raw)>0){return Number(raw);}
      var stars=widget.querySelector('.jdgm-rev-widg__summary-stars');
      if(stars){
        raw=stars.getAttribute('data-score')||stars.getAttribute('aria-label')||stars.getAttribute('title')||'';
        var match=String(raw).match(/([0-5](?:\.\d+)?)/);
        if(match&&Number(match[1])>0){return Number(match[1]);}
      }
      return 0;
    }

    function countFrom(widget){
      if(serverCount>0){return serverCount;}
      var summary=widget.querySelector('.jdgm-rev-widg__summary-text');
      var match=summary&&String(summary.textContent||'').replace(/,/g,'').match(/(\d+)\s+reviews?/i);
      return match?Number(match[1]):0;
    }

    function setExpanded(widget,expanded){
      widget.classList.toggle('willow-reviews-expanded',expanded);
      var toggle=widget.querySelector('.willow-review-toggle');
      if(toggle){
        toggle.setAttribute('aria-expanded',expanded?'true':'false');
        var label=toggle.querySelector('span');
        if(label){label.textContent=expanded?'Show fewer reviews':'Show more reviews';}
      }
      var viewAll=widget.querySelector('.willow-review-view-all');
      if(viewAll){viewAll.setAttribute('aria-expanded',expanded?'true':'false');}
    }

    function enhance(widget){
      if(!widget){return;}
      var list=widget.querySelector('.jdgm-rev-widg__reviews');
      var header=widget.querySelector('.jdgm-rev-widg__header');
      if(!list||!header){return;}

      var rating=averageFrom(widget);
      var score=header.querySelector('.willow-review-score');
      if(rating>0){
        if(!score){
          score=document.createElement('span');
          score.className='willow-review-score';
          var title=header.querySelector('.jdgm-rev-widg__title');
          if(title){title.insertAdjacentElement('afterend',score);}
          else{header.insertBefore(score,header.firstChild);}
        }
        var scoreText=rating.toFixed(1);
        if(score.textContent!==scoreText){score.textContent=scoreText;}
      }else if(score){score.remove();}

      var count=countFrom(widget);
      var viewAll=widget.querySelector('.willow-review-view-all');
      if(!viewAll){
        viewAll=document.createElement('button');
        viewAll.type='button';
        viewAll.className='willow-review-view-all';
        viewAll.setAttribute('aria-expanded','false');
        viewAll.addEventListener('click',function(){setExpanded(widget,true);});
        widget.appendChild(viewAll);
      }
      var viewLabel=count>0?'View all '+count+' review'+(count===1?'':'s'):'View reviews';
      if(viewAll.getAttribute('data-label')!==viewLabel){
        viewAll.setAttribute('data-label',viewLabel);
        viewAll.innerHTML='<b style="font:inherit">'+viewLabel+'</b><span aria-hidden="true">→</span>';
      }

      var reviews=Array.prototype.filter.call(list.children,function(node){
        return node.classList&&node.classList.contains('jdgm-rev');
      });
      reviews.forEach(function(review,index){
        review.classList.toggle('willow-review-extra',index>=3);
      });

      var button=widget.querySelector('.willow-review-toggle');
      if(reviews.length<=3){
        if(button){button.remove();}
        widget.classList.remove('willow-reviews-expanded');
        return;
      }

      if(!button){
        button=document.createElement('button');
        button.type='button';
        button.className='willow-review-toggle';
        button.setAttribute('aria-expanded','false');
        button.innerHTML='<span>Show more reviews</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 6 8 10.5 12.5 6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        button.addEventListener('click',function(){
          setExpanded(widget,!widget.classList.contains('willow-reviews-expanded'));
        });
        (widget.querySelector('.jdgm-rev-widg__body')||widget).appendChild(button);
      }
    }

    function modernCountsFrom(widget){
      var text=String(widget.textContent||'').replace(/,/g,'');
      var product=text.match(/product\s+reviews?\s*\((\d+)\)/i);
      var store=text.match(/store\s+reviews?\s*\((\d+)\)/i);
      return {
        product:product?Number(product[1]):0,
        store:store?Number(store[1]):0
      };
    }

    function modernTabFor(widget,kind){
      var tabs=widget.querySelectorAll('[role="tab"]');
      for(var i=0;i<tabs.length;i+=1){
        var label=String(tabs[i].textContent||'').toLowerCase();
        if(label.indexOf(kind+' review')>=0){return tabs[i];}
      }
      return null;
    }

    function modernActiveCount(widget,counts){
      var active=widget.querySelector('[role="tab"][aria-selected="true"]');
      var label=String(active&&active.textContent||'').toLowerCase();
      if(label.indexOf('store review')>=0){return counts.store;}
      if(label.indexOf('product review')>=0){return counts.product;}
      return counts.product>0?counts.product:counts.store;
    }

    function defaultModernTab(widget,counts){
      if(widget.__willowDefaultedReviewTab||counts.product>0||counts.store<=0){return false;}
      var storeTab=modernTabFor(widget,'store');
      if(!storeTab){return false;}
      widget.__willowDefaultedReviewTab=true;
      if(storeTab.getAttribute('aria-selected')==='true'){return false;}
      requestAnimationFrame(function(){
        if(storeTab.isConnected){storeTab.click();}
      });
      return true;
    }

    function modernAverageFrom(widget){
      if(serverRating>0){return serverRating;}
      var nodes=widget.querySelectorAll('[data-average-rating],[data-score],.jm-average-rating-display');
      for(var i=0;i<nodes.length;i+=1){
        var raw=nodes[i].getAttribute('data-average-rating')||
          nodes[i].getAttribute('data-score')||
          nodes[i].getAttribute('aria-label')||
          nodes[i].textContent||'';
        var match=String(raw).replace(',','.').match(/([0-5](?:\.\d+)?)/);
        if(match&&Number(match[1])>0){return Number(match[1]);}
      }
      return 0;
    }

    function renderModernSummary(widget,count,rating){
      var summary=widget.querySelector('.willow-jm-summary');
      if(!summary){
        summary=document.createElement('div');
        summary.className='willow-jm-summary';
        widget.insertBefore(summary,widget.firstChild);
      }
      var safeRating=rating>0?Math.min(5,rating):0;
      var signature=[count,safeRating.toFixed(2)].join('|');
      if(summary.getAttribute('data-summary')===signature){return;}
      summary.setAttribute('data-summary',signature);
      summary.innerHTML=
        '<div class="willow-jm-summary__title">Customer Reviews</div>'+
        (safeRating>0?'<div class="willow-jm-summary__score">'+safeRating.toFixed(1)+'</div>':'')+
        (safeRating>0?'<div class="willow-jm-summary__stars" aria-label="'+safeRating.toFixed(1)+' out of 5 stars" style="--willow-star-fill:'+(safeRating/5*100).toFixed(1)+'%">★★★★★</div>':'')+
        '<div class="willow-jm-summary__count">'+(count>0?count+' review'+(count===1?'':'s'):'Be the first to review')+'</div>';
    }

    function normalizeModernStars(widget){
      Array.prototype.forEach.call(widget.querySelectorAll('.jm-star-rating__font-icon'),function(star){
        var glyph=String(star.textContent||'').charCodeAt(0);
        var type=glyph===0xE001?'empty':(glyph===0xE002?'half':'filled');
        if(star.getAttribute('data-willow-star')!==type){
          star.setAttribute('data-willow-star',type);
        }
      });
    }

    function ensureModernCarousel(widget,track,reviews){
      var controls=widget.querySelector('.willow-jm-carousel-controls');
      if(!track||!reviews.length){
        if(controls){controls.remove();}
        return;
      }
      if(reviews.length>1&&!controls){
        controls=document.createElement('div');
        controls.className='willow-jm-carousel-controls';
        controls.innerHTML=
          '<button type="button" class="willow-jm-carousel-button" data-direction="-1" aria-label="Previous reviews"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 4.5 7 10l5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'+
          '<button type="button" class="willow-jm-carousel-button" data-direction="1" aria-label="Next reviews"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.5 4.5 5.5 5.5-5.5 5.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
        widget.appendChild(controls);
      }else if(reviews.length<=1&&controls){
        controls.remove();
        controls=null;
      }

      var update=function(){
        if(!controls||!controls.isConnected){return;}
        var max=Math.max(0,track.scrollWidth-track.clientWidth);
        var previous=controls.querySelector('[data-direction="-1"]');
        var next=controls.querySelector('[data-direction="1"]');
        if(previous){previous.disabled=track.scrollLeft<=3;}
        if(next){next.disabled=track.scrollLeft>=max-3;}
        var widgetRect=widget.getBoundingClientRect();
        var trackRect=track.getBoundingClientRect();
        widget.style.setProperty('--willow-jm-grid-mid',Math.round(trackRect.top-widgetRect.top+trackRect.height/2)+'px');
      };

      if(controls&&!controls.__willowCarouselControls){
        controls.__willowCarouselControls=true;
        controls.addEventListener('click',function(event){
          var control=event.target.closest('[data-direction]');
          if(!control||control.disabled){return;}
          var card=track.querySelector('.willow-jm-card');
          var gap=parseFloat(getComputedStyle(track).gap)||14;
          var step=card?card.getBoundingClientRect().width+gap:track.clientWidth*.9;
          track.scrollBy({left:step*Number(control.getAttribute('data-direction')),behavior:'smooth'});
        });
      }

      if(!track.__willowCarouselTrack){
        track.__willowCarouselTrack=true;
        var drag={active:false,moved:false,x:0,left:0,pointer:null};
        track.addEventListener('scroll',update,{passive:true});
        track.addEventListener('pointerdown',function(event){
          if(event.pointerType!=='mouse'||event.button!==0){return;}
          if(event.target.closest('a,button,input,textarea,select,label,[role="button"],[contenteditable="true"]')){return;}
          drag.active=true;
          drag.moved=false;
          drag.x=event.clientX;
          drag.left=track.scrollLeft;
          drag.pointer=event.pointerId;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        });
        track.addEventListener('pointermove',function(event){
          if(!drag.active||event.pointerId!==drag.pointer){return;}
          var delta=event.clientX-drag.x;
          if(Math.abs(delta)>5){drag.moved=true;}
          if(drag.moved){track.scrollLeft=drag.left-delta;}
        });
        var finish=function(event){
          if(!drag.active||event.pointerId!==drag.pointer){return;}
          drag.active=false;
          track.classList.remove('is-dragging');
          if(drag.moved){
            track.__willowSuppressClick=true;
            setTimeout(function(){track.__willowSuppressClick=false;},0);
          }
          update();
        };
        track.addEventListener('pointerup',finish);
        track.addEventListener('pointercancel',finish);
        track.addEventListener('click',function(event){
          if(track.__willowSuppressClick){event.preventDefault();event.stopPropagation();}
        },true);
        window.addEventListener('resize',update,{passive:true});
        if('ResizeObserver' in window){
          track.__willowCarouselResizeObserver=new ResizeObserver(update);
          track.__willowCarouselResizeObserver.observe(track);
        }
      }

      requestAnimationFrame(update);
      setTimeout(update,250);
      setTimeout(update,900);
    }

    function enhanceModern(widget){
      if(!widget){return;}
      widget.classList.add('willow-jm-enhanced');
      normalizeModernStars(widget);

      var reviews=Array.prototype.slice.call(widget.querySelectorAll('.jm-review-item,.jm-review')).filter(function(review){
        return !review.closest('form')&&review.closest(modernRootSelector)===widget;
      });
      var unique=[];
      reviews.forEach(function(review){
        if(unique.indexOf(review)<0){unique.push(review);}
      });
      reviews=unique;

      reviews.forEach(function(review,index){
        review.classList.add('willow-jm-card');
        review.classList.toggle('willow-review-extra',index>=3);
        review.classList.toggle('willow-review-mobile-extra',index>=1);
      });

      var parent=null;
      if(reviews.length){
        parent=reviews[0].parentElement;
        var sameParent=reviews.every(function(review){return review.parentElement===parent;});
        if(sameParent&&parent){
          parent.classList.add('willow-jm-grid');
          var widgetRect=widget.getBoundingClientRect();
          var gridRect=parent.getBoundingClientRect();
          var gridTop=Math.max(28,Math.round(gridRect.top-widgetRect.top));
          widget.style.setProperty('--willow-jm-grid-top',gridTop+'px');
        }
      }

      var counts=modernCountsFrom(widget);
      if(defaultModernTab(widget,counts)){return;}
      var count=modernActiveCount(widget,counts);
      var rating=modernAverageFrom(widget);
      var summary=widget.querySelector('.willow-jm-summary');
      if(count>0){
        widget.hidden=false;
        widget.removeAttribute('aria-hidden');
        renderModernSummary(widget,count,rating);
      }else if(summary){
        summary.remove();
      }

      var tabs=widget.querySelectorAll('[role="tab"]');
      if(tabs.length&&counts.product===0&&counts.store===0){
        widget.hidden=true;
        widget.setAttribute('aria-hidden','true');
      }else{
        widget.hidden=false;
        widget.removeAttribute('aria-hidden');
      }

      var viewAll=widget.querySelector('.willow-review-view-all');
      if(viewAll){viewAll.remove();}

      var button=widget.querySelector('.willow-review-toggle');
      if(button){button.remove();}
      widget.classList.remove('willow-reviews-expanded');
      ensureModernCarousel(widget,count>0?parent:null,count>0?reviews:[]);
    }

    function enhanceWidget(widget){
      if(widget.matches(modernRootSelector)){enhanceModern(widget);}
      else{enhance(widget);}
    }

    function connect(){
      var modernWidgets=Array.prototype.slice.call(document.querySelectorAll(scopedModernRootSelector));
      modernWidgets=modernWidgets.filter(function(widget,index,all){
        return all.indexOf(widget)===index&&!all.some(function(other){
          return other!==widget&&widget.contains(other);
        });
      });
      var legacyWidgets=Array.prototype.slice.call(document.querySelectorAll(
        '#judgeme_product_reviews .jdgm-rev-widg, #judgeme_product_reviews.jdgm-rev-widg'
      ));
      var widgets=modernWidgets.concat(legacyWidgets);
      if(!widgets.length){return false;}
      widgets.forEach(function(widget){
        enhanceWidget(widget);
        if(!widget.__willowReviewObserver){
          var queued=false;
          var reviewObserver=new MutationObserver(function(){
            if(queued){return;}
            queued=true;
            requestAnimationFrame(function(){
              queued=false;
              reviewObserver.disconnect();
              enhanceWidget(widget);
              reviewObserver.observe(widget,{childList:true,subtree:true});
            });
          });
          widget.__willowReviewObserver=reviewObserver;
          reviewObserver.observe(widget,{childList:true,subtree:true});
        }
      });
      return true;
    }

    function start(){
      if(connect()){return;}
      var tries=0;
      var timer=setInterval(function(){
        tries+=1;
        if(connect()||tries>80){clearInterval(timer);}
      },125);
    }

    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',start,{once:true});
    }else{start();}
    document.addEventListener('shopify:section:load',start);
  })();
